/* Hochformat-Streifen. Zwei Aufgaben: horizontal blaettern und dafuer sorgen,
   dass immer nur die sichtbaren Clips laufen.

   Die <video>-Elemente stehen mit preload="none" im Markup. Erst play() holt
   Daten vom CDN. Ohne diese Steuerung wuerde ein Streifen mit acht Clips beim
   Seitenaufruf acht Videos laden — bei einem Hero-Video, das heute schon 83 %
   des Seitengewichts ausmacht, waere das nicht vertretbar. */

const REEL_VISIBILITY = 0.6;

class PebblReels extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.pebbl-reels__track');
    this.videos = Array.from(this.querySelectorAll('[data-pebbl-reel]'));
    this.toggle = this.querySelector('[data-pebbl-reels-toggle]');
    this.icon = this.querySelector('[data-pebbl-reels-icon]');

    /* Wer reduzierte Bewegung eingestellt hat, bekommt Standbilder. Der Knopf
       bleibt bedienbar, die Entscheidung liegt dann bei der Person. */
    this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.visible = new Set();

    this.querySelectorAll('[data-direction]').forEach((button) => {
      button.addEventListener('click', () => this.scrollByDirection(button.dataset.direction));
    });

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.togglePlayback());
    }
    this.renderToggle();

    if (this.videos.length === 0) return;

    this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
      threshold: REEL_VISIBILITY,
    });
    this.videos.forEach((video) => this.observer.observe(video));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.visible.add(entry.target);
      } else {
        this.visible.delete(entry.target);
        entry.target.pause();
      }
    });
    this.syncPlayback();
  }

  syncPlayback() {
    this.visible.forEach((video) => {
      if (this.paused) {
        video.pause();
      } else {
        /* play() liefert ein Promise, das die Autoplay-Richtlinie des Browsers
           ablehnen kann. Das ist kein Fehlerfall: dann bleibt das Standbild
           stehen, und der Knopf hilft weiter. */
        const started = video.play();
        if (started && typeof started.catch === 'function') started.catch(() => {});
      }
    });
  }

  togglePlayback() {
    this.paused = !this.paused;
    this.renderToggle();
    this.syncPlayback();
  }

  renderToggle() {
    if (!this.toggle) return;
    const label = this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
    this.toggle.setAttribute('aria-label', label);
    if (this.icon) this.icon.textContent = this.paused ? '▶' : '❚❚';
  }

  scrollByDirection(direction) {
    if (!this.track) return;
    const slide = this.track.querySelector('.pebbl-reels__slide');
    if (!slide) return;

    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = slide.getBoundingClientRect().width + gap;
    this.track.scrollBy({
      left: direction === 'next' ? step : -step,
      behavior: 'smooth',
    });
  }
}

customElements.define('pebbl-reels', PebblReels);
